export enum AuthType {
  SAM = 'sam',
  IpreoAccount = 'ipreo-account',
  OKTA = 'okta'
}
